import { ref, watch } from '@nuxtjs/composition-api';
const { SHA256 } = require('jscrypto/SHA256');
const isTesseraLoaded = ref(false);
const id5Value = ref('');
export const initializeTessera = (adTags, user) => {
  if (!isTesseraLoaded.value && process.client) {
    // id5 script integration
    adTags.script.push({
      hid: 'id5',
      src: `https://cdn.id5-sync.com/api/1.0/id5-api.js`,
      async: true,
      callback: () => {
        window.ID5.init({ partnerId: 1291 }).onAvailable(function (status) {
          id5Value.value = status.getUserId();
        });
      },
    });

    watch(id5Value, () => {
      const hm = user.value ? SHA256.hash(user.value.email).toString() : '';
      const id5Query = id5Value.value ? 'if=' + id5Value.value : '';

      const tesseraScript = document.createElement('script');
      tesseraScript.setAttribute('src', `https://tpx.tesseradigital.com/dist/bundle.js?hm=${hm}&${id5Query}`);
      tesseraScript.setAttribute('async', true);
      tesseraScript.setAttribute('type', 'text/javascript');
      tesseraScript.setAttribute('hid', 'tesseraDigital');
      document.head.appendChild(tesseraScript);

      isTesseraLoaded.value = true;
    });
    adTags.__dangerouslyDisableSanitizersByTagID.tesseraDigital = ['innerHTML'];
  }
};
